<template>
  <AResult
    status="404"
    title="404"
    sub-title="Sorry, the page you tried cannot be found."
  />
</template>
